import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import type { CabinetAppInfo } from '@nebalkon-workspace/cabinet-core';
import { environment } from '@nebalkon-workspace/environments';

function devBrowserAppInfo(): CabinetAppInfo {
  return { buildLabel: environment.cabinetBuildLabel };
}

export async function loadMobileCabinetAppInfo(): Promise<CabinetAppInfo> {
  if (!Capacitor.isNativePlatform()) {
    return devBrowserAppInfo();
  }

  try {
    const info = await App.getInfo();
    const version = info.version?.trim();
    if (!version) {
      return devBrowserAppInfo();
    }

    return {
      version,
      build: info.build?.trim() || undefined,
    };
  } catch {
    return devBrowserAppInfo();
  }
}
